import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("rect", {
  x: "0",
  y: "0",
  rx: "3",
  ry: "3",
  width: "100%",
  height: "5"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  x: "0",
  y: "10",
  rx: "3",
  ry: "3",
  width: "80%",
  height: "5"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("rect", {
  x: "0",
  y: "20",
  rx: "3",
  ry: "3",
  width: "60%",
  height: "5"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_content_loader = _resolveComponent("content-loader")!

  return (_openBlock(), _createBlock(_component_content_loader, { viewBox: "0 0 300 30" }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _hoisted_3
    ]),
    _: 1
  }))
}